import Page1Row1 from '@src/Assets/images/onboarding-images/page1-row1.png';
import Page1Row2 from '@src/Assets/images/onboarding-images/page1-row2.png';
import Page1Row3 from '@src/Assets/images/onboarding-images/page1-row3.png';
import Page1Row4 from '@src/Assets/images/onboarding-images/page1-row4.png';
import Page2LeftColumn from '@src/Assets/images/onboarding-images/page2-left-column.png';
import Page2RightColumn from '@src/Assets/images/onboarding-images/page2-right-column.png';
import Page3LeftColumn from '@src/Assets/images/onboarding-images/page3-left-column.png';
import Page3RightColumn from '@src/Assets/images/onboarding-images/page3-right-column.png';
import Page4LeftColumn from '@src/Assets/images/onboarding-images/page4-left-column.png';
import Page4RightColumn from '@src/Assets/images/onboarding-images/page4-right-column.png';
import Page5LeftColumn from '@src/Assets/images/onboarding-images/page5-left-column.png';
import Page5RightColumn from '@src/Assets/images/onboarding-images/page5-right-column.png';
import Page6LeftColumn from '@src/Assets/images/onboarding-images/page6-left-column.png';
import Page6RightColumn from '@src/Assets/images/onboarding-images/page6-right-column.png';

const APP_CONSTANT = {
    IMAGES: {
        'page1-row1': Page1Row1,
        'page1-row2': Page1Row2,
        'page1-row3': Page1Row3,
        'page1-row4': Page1Row4,
        'page2-left-column': Page2LeftColumn,
        'page2-right-column': Page2RightColumn,
        'page3-left-column': Page3LeftColumn,
        'page3-right-column': Page3RightColumn,
        'page4-left-column': Page4LeftColumn,
        'page4-right-column': Page4RightColumn,
        'page5-left-column': Page5LeftColumn,
        'page5-right-column': Page5RightColumn,
        'page6-left-column': Page6LeftColumn,
        'page6-right-column': Page6RightColumn,
    },
    TEXT: {
        BACK: 'Back',
        NEXT: 'Next',
        SKIP: 'Skip feature guide',
    },
    STATUS_CODE: {
        OK: 200,
        CREATED: 201,
        NO_CONTENT: 204,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,
        SERVICE_UNAVAILABLE: 503
    },
};
export default APP_CONSTANT;

export const syncElementHeight = (classValue: string) => {
    document.querySelectorAll('.' + classValue).forEach((element: HTMLElement) => element.style.height = 'auto');
    setTimeout(() => {
        const clientHeightVal: NodeListOf<HTMLElement> = document.querySelectorAll('.' + classValue);
        const maxHeight = Math.max(...Array.from(clientHeightVal).map(v => (v as HTMLElement).clientHeight)) + 'px';
        clientHeightVal.forEach((element: HTMLElement) => element.style.height = maxHeight);
    }, 1);
};
